<template>
  <router-link class="product-item" :key="item" :to="{path:'/GoodsDetail', query:{id:item.id}}" target="_blank">
    <el-image
      style="width:100%;height:200px;"
      :src="item.cover_image"
      :key="item.cover_image"
      fit="contain"
      :alt="item.name"
    ></el-image>
    <div class="product-box">
      <span>{{item.name}}</span>
      <i>¥ {{item.price}}/天</i>
    </div>
  </router-link>
</template>
<script>
export default {
  name: "indexProduct",
  props: ["item"],
  methods: {
    jump(id) {
      let routeData = this.$router.resolve({
        path: "/GoodsDetail",
        query: {
          id: id
        },
      });
      window.open(routeData.href, "_blank");
    }
  }
};
</script>


<style lang="scss" scoped>
.product-item {
  display: block;
  cursor: pointer;
  background: #fff;
  box-shadow: 0 3px 15px #ddd;
  overflow: hidden;
  width: 200px;
  .el-image {
    width: 100%;
    display: block;
    transition: All 0.4s ease-in-out;
    -webkit-transition: All 0.4s ease-in-out;
    -moz-transition: All 0.4s ease-in-out;
    -o-transition: All 0.4s ease-in-out;
  }
  &:hover {
    box-shadow: 4px 2px 15px #999;
    .el-image {
      transform: scale(1.1);
      -webkit-transform: scale(1.1);
      -moz-transform: scale(1.1);
      -o-transform: scale(1.1);
      -ms-transform: scale(1.1);
    }
  }
  .product-box {
    padding: 10px;
    span {
      height: 34px;
      font-size: 12px;
      color: #333;
      display: block;
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
    }
    i {
      display: block;
      font-style: normal;
      font-size: 14px;
      color: #eb2525;
    }
  }
}
</style>




// WEBPACK FOOTER //
// src/components/indexProduct.vue